// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import { MenuType, useContextMenu } from "@/wab/client/components/ContextMenu";
import {
  DefaultRowGroupProps,
  PlasmicRowGroup,
} from "@/wab/client/plasmic/plasmic_kit_new_design_system_former_style_controls/PlasmicRowGroup";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import * as React from "react";

export interface RowGroupProps extends Omit<DefaultRowGroupProps, "hasMenu"> {
  style?: React.CSSProperties;
  menu?: MenuType;
  onClick?: () => void;
}

function RowGroup_(props: RowGroupProps, ref: HTMLElementRefOf<"div">) {
  const { style, menu, onClick, groupSize, ...rest } = props;
  const contextMenuProps = useContextMenu({ menu });

  return (
    <PlasmicRowGroup
      {...rest}
      root={{ ref, style, onClick, ...contextMenuProps }}
      hasMenu={!!menu}
      menuButton={{ props: { ...contextMenuProps } }}
      groupSize={
        typeof groupSize === "number" ? groupSize.toString() : groupSize
      }
    />
  );
}

const RowGroup = React.forwardRef(RowGroup_);
export default RowGroup;
